import React, {useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie'
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import SideMenu from "../components/SideMenu";
import {alpha} from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Header from "../components/Header";
import MainGrid from "../components/MainGrid";
import AppTheme from "../mui-theme/AppTheme";
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../theme/customizations';
import MouseTracker from "../components/MouseTracker";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function AccountOverview() {
  const navigate = useNavigate();
  const [cookies] = useCookies(['session-token']);

  useEffect(() => {
    if (typeof cookies['session-token'] !== "string" || cookies['session-token'].length <= 0) {
      navigate('/sign-in');
    }
  }, []);

  return (
    <AppTheme themeComponents={xThemeComponents}>
    <CssBaseline enableColorScheme />
      <MouseTracker />
      <Box sx={{ display: 'flex' }}>
        <SideMenu selected={0} />

        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <MainGrid />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  )
}